<script setup>
import { twMerge } from "tailwind-merge";

const props = defineProps({
    class: String,
});
</script>

<template>
    <thead :class="twMerge('text-sm leading-6 text-gray-900 dark:text-white border-b border-gray-300 dark:border-gray-700', props.class)">
        <tr>
            <slot></slot>
        </tr>
    </thead>
</template>
